import { Routes, Route } from 'react-router-dom';
import { ServicePicker } from './ServicePicker';
import { FastChannelConsole } from './FastChannelConsole';

/**
 * FastChannel (FAST playout) module — service_uuid-scoped, multi-tenant.
 *
 *   /services/fastchannel              → service picker
 *   /services/fastchannel/:serviceUuid/* → per-service console (ContextualSidebar:
 *                                          Channels / Storages / Cache + channel detail)
 *
 * The console owns the app's ContextualSidebar for its scope, so only one mounts at
 * a time — same scope-swap model as the AES / CDN / Compute / Kubernetes consoles.
 */
export function FastChannelPage() {
  return (
    <Routes>
      <Route index element={<ServicePicker />} />
      <Route path=":serviceUuid/*" element={<FastChannelConsole />} />
    </Routes>
  );
}

export default FastChannelPage;
